var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElementRectangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 0C5.596 0 0 5.596 0 12.5v75C0 94.404 5.596 100 12.5 100h75c6.904 0 12.5-5.596 12.5-12.5v-75C100 5.596 94.404 0 87.5 0h-75Zm68.75 18.75h-62.5v62.5h62.5v-62.5Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElementRectangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/element_rectangle.8de15305cbc7886eb8326adc29b39466.svg";